export const GlobalModals = {
    template: `
        <modal
            title="Success!"
            open="$ctrl.accountService.data.confirmToken"
            show-close-button="false"
        >
            <modal-content>
                <oo-alert severity="success">
                    <oo-alert-message>E-mail address confirmed. Thank you for creating an account with us!</oo-alert-message>
                </oo-alert>

                <button class="button button-primary button-full" ng-click="$ctrl.closeCenterModal()">Close</button>
                <div class="authentication-footer right-branding">
                    <oo-branding></oo-branding>
                </div>
            </modal-content>
        </modal>

        <ca-reset-password ng-if="$ctrl.accountService.data.resetToken"
                on-success="$ctrl.closeCenterModal()"
                reset-token="{{$ctrl.accountService.data.resetToken}}"
        ></ca-reset-password>

        <modal
            title="Invalid Link"
            open="$ctrl.accountService.data.isLinkInvalid"
            show-close-button="false"
        >
            <modal-content>
                <oo-alert severity="error">
                    <oo-alert-message>The email link has expired. Please resubmit your email to receive a new link.</oo-alert-message>
                </oo-alert>

                <button class="button button-primary button-full" ng-click="$ctrl.closeCenterModal()">Close</button>
                <div class="authentication-footer right-branding">
                    <oo-branding></oo-branding>
                </div>
            </modal-content>
        </modal>

        <slide-modal
        on-cancel="$ctrl.closeCart()"
        open="$ctrl.showCart"
        title="Cart"
        >
            <modal-content>
                <cart></cart>
            </modal-content>
            <modal-action>
                <checkout-btn ng-if="$ctrl.showCart"></checkout-btn>
            </modal-action>
        </slide-modal>
    `,
    controller: class GlobalModals {
        constructor($scope, $rootScope, ResponsiveService, $state, accountService) {
            'ngInject';
            this.accountService = accountService;
            this.$state = $state;
            this.$scope = $scope;
            this.ResponsiveService = ResponsiveService;

            this.$scope.strings = $rootScope.strings;

            this.setCartState($state.current);

            $rootScope.$on('$stateChangeSuccess', (event, toState) => {
                this.setCartState(toState);
            });
        }

        setCartState(state) {
            this.$scope.isMobile = this.ResponsiveService.data.isMobile;
            this.showCart = state.name === 'order.cart';
            if (!this.$scope.isMobile) {
                this.closeCart();
            }
        }

        closeCart() {
            if (this.showCart) {
                this.showCart = false;
                this.$state.go('order');
            }
        }

        closeCenterModal() {
            this.accountService.data.confirmToken = null;
            this.accountService.data.resetToken = null;
            this.accountService.data.isLinkInvalid = false;
        }
    }
};
